import { VistaAsset } from '@design-stack-vista/vista-assets-sdk'
import type { DesignPersonalizationContext, DesignPersonalizationText } from '@vp/personalization-types'

export interface Scheme {
  brandId?: string
  sessionId: string
  designPersonalizationContext: {
    designPersonalizationData: DesignPersonalizationContext
    designPersonalizationContextId: string
    designPersonalizationTextOverrides: DesignPersonalizationText[]
  }
  isUpdating?: boolean
}

export interface SchemesStore {
  schemes: Record<string, Scheme>
  activeSchemeId: string | undefined
}

export type SelectedAsset = { asset: VistaAsset; pageNumber: number }

export enum PURPOSE_NAMES {
  COMPANY_NAME = 'companyname',
  FULL_NAME = 'fullname',
  FAMILY_NAME = 'familyname',
}

export type TemplateField = {
  purposeName: PURPOSE_NAMES
  placeholder: string
}

export type RenderableTextField = TemplateField & {
  text: string
  isModified?: boolean
}
